module.exports = __webpack_public_path__ + "img/logo.a2e275de.png";